import { createSlice } from '@reduxjs/toolkit';

// Helper function to normalize x and y coordinates to numbers
const normalizeCoordinates = group => {
  if (!group) return group;
  return {
    ...group,
    x: Number(group.x) || 0,
    y: Number(group.y) || 0,
  };
};

const normalizeGroupList = list => {
  if (!Array.isArray(list)) return list;
  return list.map(normalizeCoordinates);
};

const commentSlice = createSlice({
  name: 'sharedPage/comments',
  initialState: {
    commentGroupLoading: false,
    commentLoading: false,
    commentGroupList: [],
    commentList: [],
    currentSelect: '',
    clickedMessageButton: true,
    uploadFiles: [],
  },
  reducers: {
    fetchCommentGroup: state => {
      state.commentGroupLoading = true;
    },
    getCommentGroupList: (state, action) => {
      state.commentGroupList = normalizeGroupList(action.payload);
      state.commentGroupLoading = false;
    },
    fetchComment: state => {
      state.commentLoading = true;
    },
    getCommentList: (state, action) => {
      state.commentList = action.payload;
      state.commentLoading = false;
    },
    addToCommentGroupList: (state, action) => {
      const normalized = normalizeCoordinates(action.payload);
      const removeTemp = state.commentGroupList.filter(li => li._id !== 'temp').concat(normalized);
      state.commentGroupList = removeTemp;
    },
    addTempCommentGroup: (state, action) => {
      state.commentGroupList.push(normalizeCoordinates(action.payload));
    },
    updateCommentGroupList: (state, action) => {
      const normalized = normalizeCoordinates(action.payload);
      state.commentGroupList = state.commentGroupList
        .filter(group => group._id !== normalized._id)
        .concat(normalized);
    },
    onDragEnd: (state, action) => {
      const x = Number(action.payload.x) || 0;
      const y = Number(action.payload.y) || 0;
      state.commentGroupList = state.commentGroupList.map(group => {
        if (group._id === action.payload._id) {
          return { ...group, x, y, updated_by: action.payload.updated_by };
        }
        return group;
      });
    },
    updateGroupData: (state, action) => {
      const payload = { ...action.payload };
      // Normalize x and y if they exist in payload
      if ('x' in payload) payload.x = Number(payload.x) || 0;
      if ('y' in payload) payload.y = Number(payload.y) || 0;
      state.commentGroupList = state.commentGroupList.map(group => {
        if (group._id === payload._id) {
          return { ...group, ...payload };
        }
        return group;
      });
    },
    addToComment: (state, action) => {
      state.commentList.push(action.payload);
    },
    setCurrentSelect: (state, action) => {
      state.currentSelect = action.payload;
    },
    removeTempGroup: state => {
      state.commentGroupList = state.commentGroupList.filter(li => li._id !== 'temp');
    },
    preUploadFile: (state, action) => {
      state.uploadFiles = [...state.uploadFiles, action.payload];
    },
    updateUploadLoading: (state, action) => {
      state.uploadFiles = state.uploadFiles.map((f) => ({...f, loading: true}));
    },
    removeFile: (state, action) => {
      state.uploadFiles = state.uploadFiles.filter(file => file.uid !== action.payload);
    },
    resetFiles: state => {
      state.uploadFiles = [];
    },
    clickedMessageButton: (state, action) => {
      state.clickedMessageButton = action.payload;
    },
  },
});

export const {
  fetchCommentGroup,
  getCommentGroupList,
  addToCommentGroupList,
  addTempCommentGroup,
  updateCommentGroupList,
  onDragEnd,
  updateGroupData,
  addToComment,
  getCommentList,
  fetchComment,
  setCurrentSelect,
  removeTempGroup,
  preUploadFile,
  updateUploadLoading,
  removeFile,
  resetFiles,
  clickedMessageButton,
} = commentSlice.actions;

export default commentSlice.reducer;
